export default __webpack_public_path__ + "static/media/Google_circle.84dbcc03.svg";